export default __webpack_public_path__ + "static/media/Children.b8b94ed3.png";